import { action, createAsyncAction } from 'typesafe-actions';
import { LmsCustomGroupI, LmsCustomGroupData } from './type';
import { TableRow } from 'components/global/Table/Table.types';
import { CustomGroupResponse } from '../customGroupList/type.d';
import * as types from './customGroup.actionTypes';

export const setShowModal = (value: boolean) => action(types.SET_SHOW_MODAL, { value });
export const setIsSuccess = (value: boolean) => action(types.SET_SUCCESS, { value });
export const createCustomGroup = createAsyncAction(
	types.CREATE_CUSTOM_GROUP_REQUEST,
	types.CREATE_CUSTOM_GROUP_SUCCESS,
	types.CREATE_CUSTOM_GROUP_FAILURE,
)<{ data: LmsCustomGroupI }, undefined, { error: string }>();
export const updateCustomGroup = createAsyncAction(
	types.UPDATE_CUSTOM_GROUP_REQUEST,
	types.UPDATE_CUSTOM_GROUP_SUCCESS,
	types.UPDATE_CUSTOM_GROUP_FAILURE,
)<{ groupID: string; data: LmsCustomGroupI }, undefined, { error: string; errorData?: string[] | null }>();
export const fetchCustomGroupById = createAsyncAction(
	types.FETCH_CUSTOM_GROUP_BY_ID_REQUEST,
	types.FETCH_CUSTOM_GROUP_BY_ID_SUCCESS,
	types.FETCH_CUSTOM_GROUP_BY_ID_FAILURE,
)<{ customGroupID: string }, { data: CustomGroupResponse }, { error: string }>();
export const deleteCustomGroup = createAsyncAction(
	types.DELETE_CUSTOM_GROUP_REQUEST,
	types.DELETE_CUSTOM_GROUP_SUCCESS,
	types.DELETE_CUSTOM_GROUP_FAILURE,
)<{ customGroupID: string }, { customGroupID: string }, { error: string }>();
export const setSelectedEditLmsCustomGroup = (data: LmsCustomGroupData) =>
	action(types.SELECTED_EDIT_LMS_CUSTOM_GROUP, { data });
// NOTE: User selection action commented out - custom groups no longer manage individual users
// export const setSelectedEditLmsUsers = (data: TableRow[]) =>
// 	action(types.SELECTED_EDIT_LMS_USERS_CUSTOM_GROUP, { data });
export const setSelectedEditLmsUserGroups = (data: TableRow[]) =>
	action(types.SELECTED_EDIT_LMS_USER_GROUPS_CUSTOM_GROUP, { data });
